import { Observable } from 'rxjs'
import { MbCheckoutContactDetailsModel } from '../../../models'

export abstract class MbCheckoutContactDetailsAdapter {

  abstract load(cartID: string): Observable<MbCheckoutContactDetailsModel>

  abstract post(form: MbCheckoutContactDetailsModel, cartID: string): Observable<any>
}
